import { Component, Input, OnDestroy } from '@angular/core';
import { ButtonComponent } from '../../../../../../shared/components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@kinomap-dev/ng-ui-lib';
@Component({
  selector: 'app-watch-sharing-modal',
  templateUrl: './watch-sharing-modal.component.html',
  styleUrls: ['./watch-sharing-modal.component.scss'],
  standalone: true,
  imports: [TranslateModule, ButtonComponent, IconComponent],
})
export class WatchSharingModalComponent implements OnDestroy {
  @Input() copied: boolean = false;

  public linkToshare: string = window.location.href;

  async copyLink(platform: string): Promise<void> {
    let shareURL: string;

    if (platform === 'facebook') {
      shareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        this.linkToshare
      )}`;
    } else if (platform === 'twitter') {
      shareURL = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        this.linkToshare
      )}`;
    }

    if (platform === 'facebook' || platform === 'twitter') {
      window.open(shareURL, '_blank');
    } else if (platform === 'email') {
      const mailtoLink: string = `mailto:?body=${encodeURIComponent(this.linkToshare)}`;
      window.location.href = mailtoLink;
    } else {
      try {
        if (
          navigator.clipboard &&
          typeof navigator.clipboard.writeText === 'function'
        ) {
          await navigator.clipboard.writeText(this.linkToshare);
          this.copied = true;
        } else {
          const tempInput = document.createElement('input');
          tempInput.value = this.linkToshare;
          document.body.appendChild(tempInput);
          tempInput.select();
          document.execCommand('copy');
          document.body.removeChild(tempInput);

          this.copied = true;
        }
      } catch (error) {
        console.error('Failed to copy link to clipboard:', error);
        this.copied = false;
      }
    }
  }

  ngOnDestroy(): void {
    this.copied = false;
  }
}
